import styled from 'styled-components';
import { spacingHelper } from '../@nitty';

const Container = styled.div`
    display: flex;
    padding: ${spacingHelper("0 medium")};
    margin: ${spacingHelper('1rem auto 1.5rem')};

    ${({ theme }) => theme.layoutBreakpoints.medium} {
        margin: ${spacingHelper('2rem auto 2.5rem')};
        max-width: calc(71.375rem + ${spacingHelper("medium")});
        padding: ${spacingHelper("0 extraLarge")};
    }
`

export { 
    Container
}